import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { MDBSpinningPreloader, MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import {RouterModule} from "@angular/router";
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {NgxsModule} from "@ngxs/store";
import {AppState} from "./states/app.state";
import {NgxsStoragePluginModule} from "@ngxs/storage-plugin";
import {NgxsResetPluginModule} from "ngxs-reset-plugin";
import {AppRoutes} from "./app.routing";
import {AuthModule} from "./components/auth/auth.module";
import {NavbarModule} from "./components/navbar/navbar.module";
import {InstrumentoState} from "./states/instrumento.state";
import {CarteraState} from "./states/cartera.state";
import { OperationsSymbolState } from './states/operations-symbol.state';
import { PaginationState } from './states/pagination.state';
import { WalletState } from './states/wallets.state';
import { PriceTotalWalletDirective } from './components/directive/price-total-wallet.directive';

@NgModule({
  declarations: [
    AppComponent,
    PriceTotalWalletDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxsModule.forRoot([AppState, InstrumentoState, CarteraState, OperationsSymbolState, PaginationState, WalletState], {
      developmentMode: !environment.production
    }),
    NgxsStoragePluginModule.forRoot({
      key: [AppState, InstrumentoState, CarteraState, OperationsSymbolState, PaginationState, WalletState]
    }),
    NgxsResetPluginModule.forRoot(),
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    RouterModule.forRoot(AppRoutes, {
      useHash: false,
      onSameUrlNavigation: 'reload',
      anchorScrolling: 'enabled',
      enableTracing: false,
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    AuthModule,
    NavbarModule,
  ],
  providers: [MDBSpinningPreloader],
  bootstrap: [AppComponent],
  schemas:      [ NO_ERRORS_SCHEMA ]
})
export class AppModule { }
